import React,{useState} from "react";
import emailjs from 'emailjs-com';
import { toast   } from "react-toastify";


const ContactUs=()=>{
  const [name,setName]=useState("");
  const [email,setEmail]=useState("");
  const [message,setMessage]=useState("");


  const handleSubmit=(e)=>{
    e.preventDefault();
    console.log(e.target)
    emailjs.sendForm('service_s2b3hvc', 'template_jr1z4nd', e.target, 'YVHKOrjkktPW4GsLZ')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
      toast("Thank you..",{type:"success"})
      setEmail("")
      setMessage("")
      setName("")
      
  }
    return(
      
      <div className="w-full md:h-screen" name="contact">
        
      <div className="max-w-screen-lg mx-auto p-4 flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">Contact Me</p>
        </div>
        <div className="flex justify-center items-center ">
          <form className="flex flex-col w-full md:w-1/2" onSubmit={handleSubmit}>
            <input type="text" name="name" placeholder="Enter your name" value={name} onChange={(e)=>setName(e.target.value)} className="p-2 border-2 rounded-md  focus:outline-none"/>
            <input type="email" name="email" placeholder="Enter your email" className="my-4 p-2 bg-transparent border-2 rounded-md  focus:outline-none" value={email} onChange={e=>setEmail(e.target.value)}/>
            <textarea name="message" rows="10" placeholder="Enter your message" className="p-2 bg-transparent border-2 rounded-md focus:outline-none" value={message} onChange={e=>setMessage(e.target.value)}></textarea>
            <button className="text-white bg-gradient-to-b from-purple-500 to-blue-500 px-6 py-3 my-8 mx-auto flex items-center rounded-md hover:scale-100 duration-150">Send Message</button>
          </form>
         
        </div>
        
    </div>
    </div>
    )
}

export default ContactUs;